import React from 'react';
import { getBotTypeLabel, getCompositionSummary, isBotSelected } from '../Bots/botUtils';

/**
 * props:
 * - automationIds
 * - bots
 * - onChange
 */
function BotsBacktestList({ automationIds, bots, onChange }) {
    function onBotToggle(bot, event) {
        onChange({ target: { id: 'automationIds', value: bot, checked: event.target.checked } });
    }

    if (!bots?.length) {
        return <p className="backtest-bots-empty">No saved bots found for this pair.</p>;
    }

    return (
        <ul className="list-group divAutomationsList backtest-bots-list">
            {bots.map((bot) => (
                <li className="list-group-item backtest-bots-item" key={bot.id}>
                    <label className="backtest-bots-label">
                        <input
                            className="form-check-input me-2"
                            type="checkbox"
                            checked={isBotSelected(bot, automationIds)}
                            onChange={(event) => onBotToggle(bot, event)}
                        />
                        <span className={`bot-type-badge bot-type-badge--${(bot.type || 'unknown').toLowerCase()}`}>
                            {getBotTypeLabel(bot.type)}
                        </span>
                        <span className="backtest-bots-name">{bot.name}</span>
                        {bot.composition ? (
                            <span className="backtest-bots-meta">{getCompositionSummary(bot)}</span>
                        ) : null}
                    </label>
                </li>
            ))}
        </ul>
    );
}

export default BotsBacktestList;